import { render, staticRenderFns } from "./uiGroupSelect.vue?vue&type=template&id=51c35497&"
import script from "./uiGroupSelect.vue?vue&type=script&lang=js&"
export * from "./uiGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports